import { ScanRatio } from 'core/flow/entities';
import { useIsMobile } from 'core/theme_deprecated/hooks';
import { useConfig } from './useConfig';

const horizontalGuttersPx = 32;
const defaultVideoWidth = 320;
const defaultVideoHeight = 424;

type UseScanSizeParams = {
  ratio?: ScanRatio;
  video?: HTMLVideoElement | null;
};

export const useScanSize = ({ ratio = ScanRatio.PORTRAIT, video }: UseScanSizeParams = {}) => {
  const { isMobile } = useIsMobile();
  const { scanRatio } = useConfig();

  const { width, height } = scanRatio[ratio];

  if (video) {
    const videoElementWidth = video.getBoundingClientRect().width ?? defaultVideoWidth;
    const videoElementHeight = video.getBoundingClientRect().height ?? defaultVideoHeight;

    const adjustedWidth = video.getBoundingClientRect().width - horizontalGuttersPx;
    const originalAspectRatio = videoElementWidth / videoElementHeight;
    const adjustedHeight = adjustedWidth / originalAspectRatio;

    return {
      width: adjustedWidth,
      height: adjustedHeight,
    };
  }

  return {
    width: isMobile ? width : height,
    height: isMobile ? height : width,
  };
};
